// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--pkUvP","logo":"da51a739f7--logo--dyshZ","title":"da51a739f7--title--IRO0Y"};